module.exports = __webpack_public_path__ + "static/media/white-logo-icon.e9ad2c2c.svg";